import { ACTIVE_STATUS_FILTER_VALUE } from '@/utils/filters';

export const DEFAULT_DASHBOARD_PAGE_SIZE = 50;

export const ZM_STATUS_FILTER_KEY = 'zmStatus';

export const DEFAULT_ZM_STATUS = ACTIVE_STATUS_FILTER_VALUE.active;

export const DCR_TYPE_COLUMNS = [
  {
    id: 1,
    key: 'sdCount',
    label: 'SD',
    title: 'Specimen Distribution',
  },
  {
    id: 2,
    key: 'mpCount',
    label: 'MP',
    title: 'Marketing Promotion',
  },
  {
    id: 3,
    key: 'tcCount',
    label: 'TC',
    title: 'Teacher Contact',
  },
  {
    id: 4,
    key: 'lcCount',
    label: 'LC',
    title: 'Library Contact',
  },
  {
    id: 5,
    key: 'owCount',
    label: 'OW',
    title: 'Official Work',
  },
  {
    id: 6,
    key: 'csrCount',
    label: 'CSR',
    title: 'CSR - Specimen',
  },
] as const;
